export const Logo = ({ className = "h-10 w-10" }) => (
  <svg viewBox="0 0 100 100" className={className} data-testid="lg-logo" aria-label="LG logo">
    <g transform="rotate(45 50 50)">
      <rect x="22" y="22" width="56" height="56" fill="#3E2723" />
      <path
        d="M38 32 v30 h20 M56 44 h12 v14 h-12"
        stroke="#F5F2EC"
        strokeWidth="6"
        fill="none"
        strokeLinecap="square"
      />
    </g>
  </svg>
);
